export enum UserStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
